import * as ProgressPrimitive from "@radix-ui/react-progress";
import clsx from "clsx";
import * as React from "react";

const ProgressBar = React.forwardRef<
	React.ElementRef<typeof ProgressPrimitive.Root>,
	React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> & {
		childrenClassName?: string;
	}
>(({ className, value, childrenClassName, ...props }, ref) => {
	return (
		<ProgressPrimitive.Root
			ref={ref}
			className={clsx("relative w-full overflow-hidden rounded-full bg-neutral-100", className)}
			{...props}
		>
			<ProgressPrimitive.Indicator
				style={{ transform: `translateX(-${100 - (value ?? 0)}%)` }}
				className={clsx("size-full flex-1 transition-all", childrenClassName ?? "bg-warning-100")}
			/>
		</ProgressPrimitive.Root>
	);
});
ProgressBar.displayName = ProgressPrimitive.Root.displayName;

export { ProgressBar };
